module.exports = __webpack_public_path__ + "files/0d5b550170ef24af423bd7f61a778423.png";